// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__A6xn5","spin":"styles_spin__HXw1X"};